<button [disabled]="isBusy || disabled">
  <span class="button-content">
    <ng-content select="mat-icon, svg-icon" />
    <ng-content />
  </span>
</button>
